module.exports = __webpack_public_path__ + "static/media/selling-water-table-service-01.d11b15e8.jpg";